import { useSelector } from 'react-redux';
import { cx } from '@/styled-system/css';
import TooltipV2 from 'app/shared/modules/TooltipV2';
import IconVerified from 'images/verified.svg';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import * as styles from './photoGallery.styles';

const VERIFIED_TEXT =
  'This listing comes to HotPads from a verified source, ' +
  "a known and established property manager or property manager's representative.";

type VerifiedBadgeProps = {
  hasOtherMobileBadges?: boolean;
};

export const VerifiedBadge = ({ hasOtherMobileBadges }: VerifiedBadgeProps) => {
  const isMobile = useSelector((state: RootReduxState) => state.app.device.screenWidth === 'sm');

  return (
    <div className={cx(styles.verifiedBadge, hasOtherMobileBadges && styles.verifiedBadgeAboveBadges)}>
      <TooltipV2 content={VERIFIED_TEXT} position={isMobile ? 'above' : 'below'} size="sm">
        <span className={styles.verifiedBadgeInner}>
          <img src={IconVerified} alt="" className={styles.verifiedIcon} aria-hidden="true" />
          <span className={styles.verifiedLabel}>Verified</span>
        </span>
      </TooltipV2>
    </div>
  );
};
